import '../App.css';
import React from 'react';
import Login from '../auth/Login'
import DigestHome from './DigestHome';
import { useEffect, useState } from 'react';
import { serverURL } from '../constants';
import '../index.css'
import IssueCollector from './IssueCollector';
import { isChrome, isEdge, isDesktop } from 'react-device-detect';

function App() {
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const fetchCurrentUser = async () => {
      try {
          const response = await fetch(`${serverURL}/currentuser`, {
              method: 'GET',
              credentials: 'include',
              headers: {
                  'Content-Type': 'application/json'
              }
          });
  
          if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
          }
  
          const data = await response.json();
          
          if (data.user) {
              setAuthenticated(true);
          } else {
              setAuthenticated(false);
          }
  
      } catch (err) {
          console.error(err);
      }
  };

  fetchCurrentUser();
  
}, []);



  return (
    <div className="App">
      {isDesktop || isEdge || isChrome ? (
        authenticated ? (
          <div>
            <DigestHome setAuthenticated={setAuthenticated} />
          </div>
        ) : (
          <Login />
        )
      ) : (
        <div>Clip Digest is currently only available on desktop versions of Google Chrome or Microsoft Edge.</div>
      )}

      <IssueCollector />
    </div>
  );

}
export default App;
